import request from "../request";

export class ItemService {
  
  static get = async (styleCode) => {
    return await request.get(`/items/${styleCode}`);
  };

}